import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-load-image',
  templateUrl: './load-image.component.html',
  styleUrls: ['./load-image.component.scss'],
})
export class LoadImageComponent implements OnInit {
  @ViewChild('loadImage', { static: false }) readonly loadImage: ElementRef;
  @Input() urlImage: string;
  @Input() typeImage: string;
  @Input() height: number;
  @Input() width: number;
  @Output() file: EventEmitter<File>;

  constructor(
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.loadImage = {} as ElementRef;
    this.file = new EventEmitter<File>();
    this.urlImage = '';
    this.typeImage = 'circle';
    this.height = 150;
    this.width = 150;
  }

  ngOnInit(): void {}

  openImage(): void {
    this.loadImage.nativeElement.click();
  }

  changeImage(): void {
    const image: FileList = this.loadImage.nativeElement.files;
    if (!image || !image.length) {
      return;
    }
    if (image[0].type == 'image/png' || image[0].type == 'image/jpeg') {
      this.urlImage = URL.createObjectURL(image[0]);
      this.file.emit(this.loadImage.nativeElement.files[0]);
      return;
    }
    forkJoin([
      this.translate.get('error'),
      this.translate.get('only_files_jpg_png'),
    ]).subscribe((translate) => {
      this.toastr.error(translate[1], translate[0].toUpperCase());
    });
    this.loadImage.nativeElement.value = null;
    this.urlImage = '';
    this.file.emit({} as File);
  }

  sanitize(): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.urlImage);
  }
}
